class VwRadyolojiKabulislemlerDTO {
    id: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    tarih?: string = null;
    servisId?: number = null;
    doktorId?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    redTarih?: string = null;
    redKullanici?: number = null;
    redNedenId?: number = null;
    redAciklama?: string = "";
    islemTanimId?: number = null;
    servisAdi?: string = "";
    organizasyonAdi?: string = "";
    doktorAdiSoyadi?: string = "";
    orderRadyolojiId?: number = null;
    orderDetayId?: number = null;
    acil?: string = "";
    kabulTarihi?: string = null;
    cekimTarihi?: string = null;
    kabulEdenId?: number = null;
    cihazId?: number = null;
    taraf?: number = null;
    hastaAdiSoyadi?: string = "";
    orderId?: number = null;
    kurumId?: number = null;
    kimlikNo?: string = "";
    islemAdi?: string = "";
    raportiptanimId?: number = null;
    raportiptanimAdi?: string = "";
    fkHbsCihazhastarandevuId?: number = null;
    rndBastarih?: string = "";
    rndBittarih?: string = "";
    rndCihazId?: number = null;
    rndId?: number = null;
}
export default VwRadyolojiKabulislemlerDTO;